import { render, staticRenderFns } from "./Skewness.vue?vue&type=template&id=4cde85d1&scoped=true"
import script from "./Skewness.vue?vue&type=script&lang=js"
export * from "./Skewness.vue?vue&type=script&lang=js"
import style0 from "./Skewness.vue?vue&type=style&index=0&id=4cde85d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde85d1",
  null
  
)

export default component.exports